require('../../modules/es6.array.join');
module.exports = require('../../modules/_core').Array.join;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/array/join.js
// module id = 781
// module chunks = 29